var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFailIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 57,
    viewBox: "0 0 56 57",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28 56.5C43.464 56.5 56 43.964 56 28.5C56 13.036 43.464 0.5 28 0.5C12.536 0.5 0 13.036 0 28.5C0 43.964 12.536 56.5 28 56.5ZM21.9812 18.7688C20.956 17.7437 19.294 17.7437 18.2688 18.7688C17.2437 19.794 17.2437 21.456 18.2688 22.4812L24.2877 28.5L18.2688 34.5188C17.2437 35.544 17.2437 37.206 18.2688 38.2312C19.294 39.2563 20.956 39.2563 21.9812 38.2312L28 32.2123L34.0188 38.2312C35.044 39.2563 36.706 39.2563 37.7312 38.2312C38.7563 37.206 38.7563 35.544 37.7312 34.5188L31.7123 28.5L37.7312 22.4812C38.7563 21.456 38.7563 19.794 37.7312 18.7688C36.706 17.7437 35.044 17.7437 34.0188 18.7688L28 24.7877L21.9812 18.7688Z",
    fill: "#E30613"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFailIcon);
export default __webpack_public_path__ + "static/media/FailIcon.6f3e4890391fdf3d5929d15156ac6762.svg";
export { ForwardRef as ReactComponent };